import { apiClient, handleResp } from './utils';

export default {
  async registerGuest(data) {
    return handleResp((await apiClient()).post('/guest/register', data));
  },
};
